module.exports = __webpack_public_path__ + "static/bear-d7a964ce22f4db7004e8310df4d7f1d7.png";